import { preview } from '@/components/form/preview'
import { useOrderViolationTexts } from '@/intl'
import { useTexts } from './hooks/useTexts'
import { BulkViewData } from '../../hooks/useBulkViewData/types'
import { MixedTag } from '../../../components/MixedTag'

type Props = {
  bulkData: BulkViewData
}

export function BannedTags(props: Props) {
  const {
    bulkData: { tagsOut, violations },
  } = props
  const { getViolationText } = useOrderViolationTexts()
  const texts = useTexts()
  const hasViolations = violations?.has('TGO')
  const tagsCount = tagsOut.value.length

  if (tagsCount === 0 && !tagsOut.hasAlsoMixedValues) {
    return (
      <preview.Field label={texts.bannedTags.label(tagsCount)}>
        <preview.NullValue />
      </preview.Field>
    )
  }

  if (tagsCount === 0 && tagsOut.hasAlsoMixedValues) {
    return (
      <preview.Field label={texts.bannedTags.label(tagsCount)}>
        <MixedTag>(mixed)</MixedTag>
      </preview.Field>
    )
  }

  return (
    <preview.Field label={texts.bannedTags.label(tagsCount)}>
      <preview.ViolationContainer
        violation={
          hasViolations ? <preview.ViolationBadge tooltip={getViolationText('TGO')} /> : null
        }
      >
        <preview.TagsList
          tags={tagsOut.value}
          maxHeightPx={48}
          extraTagContent={tagsOut.hasAlsoMixedValues ? <MixedTag /> : null}
        />
      </preview.ViolationContainer>
    </preview.Field>
  )
}
